export type DemoTourScriptStep =
  | { kind: "cosmos"; holdMs: number }
  | { kind: "node"; id: string; holdMs: number }
  | { kind: "orbital"; id: string; parentId: string; holdMs: number };

export const DEMO_TOUR_SCRIPT: DemoTourScriptStep[] = [
  { kind: "cosmos", holdMs: 2200 },
  { kind: "node", id: "kaim-dev", holdMs: 6200 },
  { kind: "orbital", id: "kaim-nexus-connector", parentId: "kaim-dev", holdMs: 3400 },
  { kind: "node", id: "build", holdMs: 5200 },
  { kind: "node", id: "house", holdMs: 4200 },
  { kind: "node", id: "okolica", holdMs: 4600 },
  { kind: "node", id: "goals", holdMs: 5000 },
  { kind: "orbital", id: "goals-futures-ui", parentId: "goals", holdMs: 3400 },
  { kind: "node", id: "photos", holdMs: 4500 },
  { kind: "orbital", id: "photos-roza-instance", parentId: "photos", holdMs: 3200 },
  { kind: "node", id: "home", holdMs: 4000 },
  { kind: "node", id: "breakglass", holdMs: 4100 },
  { kind: "cosmos", holdMs: 3200 },
];
